import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "var(--cream-50)" }}>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
